export {default as MainC} from './components/main';
export {default as AddC} from './components/add';



// WEBPACK FOOTER //
// src/modules/vehiculos/component.js